export const CSV_FILENAME = 'searchs_summary.csv';
